import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  ButtonProps,
  Divider,
  Drawer,
  DrawerProps,
  IconButton,
  Typography,
} from '@mui/material';
import React, { ReactElement } from 'react';

interface Props {
  title: string;
  ButtonProps?: ButtonProps;
  DrawerProps?: DrawerProps;
  // This component's child can accept `onClose` as a prop.
  // If it does, this component, which manages the drawer open/close state, will pass it down.
  // This avoids lifting state up into the parent
  children?: ReactElement<{ onClose?: () => void }>;
}

// Common component for a button that opens a drawer
const CommonButtonDrawer: React.FC<Props> = ({
  title,
  ButtonProps,
  DrawerProps,
  children,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        variant='text'
        color='grayscale'
        onClick={() => setOpen(true)}
        {...ButtonProps}
      >
        {title}
      </Button>
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        anchor='right'
        sx={{
          '& .MuiDrawer-paper': {
            borderTop: 'none',
            width: '500px',
            maxWidth: '100%',
          },
        }}
        {...DrawerProps}
      >
        <Typography p={2} component='h2' variant='h5'>
          {title}
        </Typography>
        <IconButton
          aria-label='close'
          onClick={() => setOpen(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'grayscale.light',
          }}
        >
          <CloseIcon />
        </IconButton>
        <Divider orientation='horizontal' flexItem />
        {children && React.cloneElement(children, { onClose: handleClose })}
      </Drawer>
    </>
  );
};

export default CommonButtonDrawer;
